import { Directive, Input, HostListener } from '@angular/core';

@Directive({
  selector: '[sts-trigger-focus]'
})
export class TriggerFocusDirective {
  @Input('sts-trigger-focus') elementToFocus: string;
  private counter = 0;

  constructor() {
  }

  @HostListener('click') onClick() {
    this.counter = 0;
    this.focusElement();
  }

  focusElement() {
    setTimeout(() => {
      if (this.elementToFocus) {
        const element = document.getElementById(this.elementToFocus);
        if (element) {
          element.focus();
          this.counter = 0;          
        } else {
          if(this.counter < 50){
            this.counter++;
            this.focusElement();
          }
        }
      }
    }, 500);
  }

}



// WEBPACK FOOTER //
// ./src/app/lib/trigger-focus/trigger-focus.directive.ts